// Account Receivable Payments Getters

export const getPaymentsList = state => {
  return state.paymentsList
}

export const getPaymentInfo = state => {
  return state.paymentInfo
}
